import { TooltipProvider } from '@aulastack/ui'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { lazy, StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router'
import { Toaster } from 'sonner'
import { Carregando } from './comum'
import './estilos.css'

// Cada área é um pedaço próprio do bundle: o aluno não baixa o painel, e vice-versa.
const AreaDoAluno = lazy(() => import('./aluno/AreaDoAluno'))
// /gestao é a galeria dos módulos (e leva os endereços antigos aos novos); o Ambiente mora em /ambiente
const EntradaDaGestao = lazy(() => import('./gestao/Galeria'))
const PainelAmbiente = lazy(() => import('./gestao/PainelAmbiente'))
const PainelComercial = lazy(() => import('./comercial/PainelComercial'))
const PainelOperacao = lazy(() => import('./operacao/PainelOperacao'))
const PainelTreinamento = lazy(() => import('./treinamento/PainelTreinamento'))
const PainelLive = lazy(() => import('./live/PainelLive'))
const Entrar = lazy(() => import('./entrada/Entrar'))
const Legal = lazy(() => import('./legal/Legal'))
const ConviteEncontro = lazy(() => import('./aovivo/Convite'))
const ConvidadoEncontro = lazy(() => import('./aovivo/Convidado'))
// a página que a plataforma de vídeo grava (docs/16): sem sessão, pela chave do encontro
const PaginaDeGravacao = lazy(() => import('./aovivo/Gravacao'))

const consultas = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 } },
})

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('elemento #raiz ausente no index.html')

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={consultas}>
      <BrowserRouter>
        {/* as dicas do kit (Dica/Tooltip) precisam do provedor na raiz */}
        <TooltipProvider delayDuration={300}>
          <Suspense fallback={<Carregando />}>
            <Routes>
              <Route path="/login" element={<Entrar />} />
              <Route path="/legal/:doc?" element={<Legal />} />
              <Route path="/encontro/:codigo" element={<ConviteEncontro />} />
              <Route path="/convidado/:codigo" element={<ConvidadoEncontro />} />
              <Route path="/gravacao/:id/:chave" element={<PaginaDeGravacao />} />
              <Route path="/gestao/*" element={<EntradaDaGestao />} />
              <Route path="/ambiente/*" element={<PainelAmbiente />} />
              <Route path="/comercial/*" element={<PainelComercial />} />
              <Route path="/operacao/*" element={<PainelOperacao />} />
              <Route path="/treinamento/*" element={<PainelTreinamento />} />
              <Route path="/live/*" element={<PainelLive />} />
              {/* a raiz é a vitrine, servida pelo worker (docs/10); a área do aluno mora em /aluno */}
              <Route path="/aluno/*" element={<AreaDoAluno />} />
              <Route path="*" element={<AreaDoAluno />} />
            </Routes>
          </Suspense>
        </TooltipProvider>
      </BrowserRouter>
      <Toaster position="bottom-center" toastOptions={{ style: { fontFamily: 'inherit' } }} />
    </QueryClientProvider>
  </StrictMode>,
)
